import { render, staticRenderFns } from "./FormPrestadores.vue?vue&type=template&id=c336eea8&scoped=true&"
import script from "./FormPrestadores.vue?vue&type=script&lang=js&"
export * from "./FormPrestadores.vue?vue&type=script&lang=js&"
import style0 from "./FormPrestadores.vue?vue&type=style&index=0&id=c336eea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c336eea8",
  null
  
)

export default component.exports